import { render, staticRenderFns } from "./DraggableSeparator.vue?vue&type=template&id=8fe0253e&scoped=true"
import script from "./DraggableSeparator.vue?vue&type=script&setup=true&lang=ts"
export * from "./DraggableSeparator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DraggableSeparator.vue?vue&type=style&index=0&id=8fe0253e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe0253e",
  null
  
)

export default component.exports